import React from 'react';

/**
 * Loading spinner component
 */
export const Loading = ({ text = 'Cargando...' }) => {
  return (
    <div className="loading">
      <div className="loading-spinner"></div>
      <div className="loading-text">{text}</div>
    </div>
  );
};
